const getChartColorsArray = (colors: string | string[]): string[] => {
  let parsedColors: string[] = [];

  try {
    if (typeof colors === 'string') {
      parsedColors = JSON.parse(colors);
    } else {
      parsedColors = colors;
    }
  } catch (e) {
    console.error('Invalid dataColors format. Expected JSON stringified array.', e);
    return [];
  }

  return parsedColors.map((value) => {
    const newValue = value.replace(/\s/g, '');
    if (newValue.indexOf(',') === -1) {
      const color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
      return color.trim() || newValue;
    } else {
      const val = newValue.split(',');
      if (val.length === 2) {
        const rgba = getComputedStyle(document.documentElement).getPropertyValue(val[0]).trim();
        return `rgba(${rgba},${val[1]})`;
      }
      return newValue;
    }
  });
};

export default getChartColorsArray;
